<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn class="mx-2" fab dark small color="success"  @click="$router.push({ name: 'Home' })">
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <div 
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 white--text primary-text" 
          :class="{'text-h6': $vuetify.breakpoint.xsOnly}"
          style="font-size: 16px;" 
        >
          {{ title }}
        </div>
        <div>
          <!-- Tabla para pantallas grandes -->
          <v-simple-table v-if="!$vuetify.breakpoint.xsOnly">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Materia
                  </th>
                  <th class="text-left">
                    Parcial 1
                  </th>
                  <th class="text-left">
                    Parcial 2
                  </th>
                  <th class="text-left">
                    Recuperatorio
                  </th>
                  <th class="text-left">
                    Examen Final
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(notaData, notaKey) in notas" :key="notaKey">
                  <td>{{ notaData.nombre_materia !== null ? notaData.nombre_materia : 'No aplica' }}</td>
                  <td>{{ notaData.parcial1 !== null ? notaData.parcial1 : 'No aplica' }}</td>
                  <td>{{ notaData.parcial2 !== null ? notaData.parcial2 : 'No aplica' }}</td>
                  <td>{{ notaData.recuperatorio !== null ? notaData.recuperatorio : 'No aplica'  }}</td>
                  <td>{{ notaData.final !== null ? notaData.final : 'No aplica'  }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <!-- Tarjetas para pantallas pequeñas -->
          <v-expansion-panels v-else>
            <v-expansion-panel 
              v-for="(notaData, notaKey) in notas" 
              :key="notaKey"
              class="custom-panel"
            >
              <v-expansion-panel-header 
                style="background-color: #e0e0e0;"
              >
                <div>{{ notaData.nombre_materia }}</div>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="custom-content">
                <v-row>
                  <v-col cols="12" sm="6">
                    <div><strong>Parcial 1:</strong> {{ notaData.parcial1 !== null ? notaData.parcial1 : 'No aplica' }}</div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div><strong>Parcial 2:</strong> {{ notaData.parcial2 !== null ? notaData.parcial2 : 'No aplica'  }}</div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div><strong>Recuperatorio:</strong> {{ notaData.recuperatorio !== null ? notaData.recuperatorio : 'No aplica' }}</div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <div><strong>Examen Final:</strong> {{ notaData.final !== null ? notaData.final : 'No aplica' }}</div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title: "Notas Materias",
    notas: [],
  }),

  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.$API
      .get({
        url: "examenes/notas"
      }).then((res) => {
        let dataFromBackend = res;
        let processedData = [];
// Recorremos cada curso
for (let curso in dataFromBackend) {
  dataFromBackend[curso].forEach((materia) => {
    // Extraemos la información que vamos a mostrar en la tabla
    processedData.push({
      nombre_curso: materia.nombre_curso,
      nombre_materia: materia.nombre_materia,
      parcial1: materia.parcial1,
      parcial2: materia.parcial2,
      recuperatorio: materia.recuperatorio,
      final: materia.estado_final, // Usamos estado_final como "Examen Final"
    });
  });
}

// Asignamos los datos procesados a la variable notas
this.notas = processedData;
      });
  },
};
</script>
<style scoped>
.custom-panel {
  border-radius: 5px !important; /* Asegura el redondeo del panel */
  margin-bottom: 5px !important; /* Espacio entre los paneles */
  overflow: hidden; /* Asegura que el contenido no sobresalga de las esquinas redondeadas */
}

.custom-header {
  background-color: #e0e0e0 !important; /* Color de fondo del header */
  border-radius: 5px 5px 0 0 !important; /* Redondeo de las esquinas superiores */
}

.custom-content {
  padding-top: 10px !important; /* Separación entre el header y el contenido */
  padding-bottom: 10px !important;
  border-radius: 0 0 5px 5px !important; /* Redondeo de las esquinas inferiores */
}

.v-expansion-panel--collapsed .custom-header {
  border-radius: 5px 5px 0 0 !important; /* Asegura el redondeo cuando está cerrado */
}

.v-expansion-panel--collapsed {
  border-radius: 5px !important; /* Asegura el redondeo cuando el panel está cerrado */
  margin-bottom: 5px !important; /* Espacio entre los paneles */
}

.v-expansion-panel--open .custom-content {
  border-radius: 0 0 5px 5px !important; /* Redondeo en la parte inferior cuando el panel está abierto */
}

</style>